import gql from 'graphql-tag';

export const ADMIN_CREATE_DASHBOARD = gql`
  mutation CreateDashboard($input: CreateExternalDashboardsInput!) {
    externalDashboards {
      result: adminCreateDashboard(input: $input) {
        error
        success
        entity {
          id
        }
      }
    }
  }
`;
